export enum ClientsSortField {
  Name = 'name',
  Email = 'email',
  Company = 'company',
  JobTitle = 'jobtitle',
  Onboarding = 'onboarding',
  CreatedAt = 'createdat'
}
